import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideChevronDown, lucidePlus, lucideStore, lucideUserPlus } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';

/**
 * "Kunde hinzufügen": the one entry point, split by the only question that matters
 * to the agency: does the customer already have a Schenkwerk account?
 */
@Component({
  selector: 'app-add-client-menu',
  standalone: true,
  imports: [NgIcon, HlmButtonImports, HlmDropdownMenuImports],
  providers: [provideIcons({ lucideChevronDown, lucidePlus, lucideStore, lucideUserPlus })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button hlmBtn type="button" [variant]="variant()" [hlmDropdownMenuTrigger]="menu" align="end">
      <ng-icon name="lucidePlus" data-icon="inline-start" />
      Kunde hinzufügen
      <ng-icon name="lucideChevronDown" data-icon="inline-end" />
    </button>

    <ng-template #menu>
      <hlm-dropdown-menu class="w-80">
        <button
          hlmDropdownMenuItem
          class="items-start justify-start text-left"
          (click)="createNew.emit()">
          <ng-icon name="lucideUserPlus" class="mt-0.5" />
          <span class="flex flex-col items-start gap-0.5 text-left">
            <span class="font-medium">Neuer Kunde</span>
            <span class="text-muted-foreground text-xs">
              Noch nicht bei Schenkwerk. Du legst das Konto an und richtest es ein.
            </span>
          </span>
        </button>
        <button
          hlmDropdownMenuItem
          class="items-start justify-start text-left"
          (click)="addExisting.emit()">
          <ng-icon name="lucideStore" class="mt-0.5" />
          <span class="flex flex-col items-start gap-0.5 text-left">
            <span class="font-medium">Kunde mit Schenkwerk-Konto</span>
            <span class="text-muted-foreground text-xs">
              Nutzt Schenkwerk schon. Wir fragen ihn, ob du in seinem Konto arbeiten darfst.
            </span>
          </span>
        </button>
      </hlm-dropdown-menu>
    </ng-template>
  `,
})
export class AddClientMenuComponent {
  readonly variant = input<'default' | 'outline'>('default');
  readonly createNew = output<void>();
  readonly addExisting = output<void>();
}
